{
  "nl": {
    "aiImage": {
      "confirm": {
        "deleteImage": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. De afbeelding wordt permanent uit je geschiedenis verwijderd.",
          "title": "Afbeelding verwijderen?"
        },
        "moveAllToTrash": {
          "text": "Alle afbeeldingen worden uit je geschiedenis verwijderd. Je vindt ze daarna in de prullenbak.",
          "title": "Afbeeldingen naar de prullenbak verplaatsen?"
        }
      },
      "errors": {
        "generationFailed": "Afbeelding genereren mislukt. Probeer het opnieuw.",
        "generationTimeout": "Het genereren van de afbeelding duurt ongewoon lang en is geannuleerd. Probeer het opnieuw.",
        "loadFailed": "De afbeelding kon niet worden geladen. Deze is mogelijk verwijderd of je hebt er geen toegang toe.",
        "rateLimitExceeded": "Je hebt te veel afbeeldingen in korte tijd gemaakt. Wacht even en probeer het opnieuw."
      },
      "headers": {
        "form": "Eigen afbeelding laten maken",
        "proposals": "Suggesties"
      },
      "hints": {
        "progressMessage": "Afbeelding wordt gegenereerd..."
      },
      "imageStyles": {
        "concept_art": "Concept Art",
        "custom": "Standaard",
        "drawing": "Tekening",
        "graphics_3d": "3D Grafiek",
        "origami": "Origami",
        "painting": "Schilderij",
        "photo": "Foto",
        "polaroid": "Polaroid"
      },
      "labels": {
        "copyPrompt": "Prompt kopiëren",
        "create": "Afbeelding aanmaken",
        "createdAt": "Aangemaakt op",
        "imageSize": "Afbeeldingsgrootte",
        "imageStyle": "Stijl",
        "model": "Model",
        "openImageInNewTab": "Afbeelding openen in nieuw tabblad",
        "prompt": "Prompt",
        "promptDescribe": "Beschrijf de afbeelding",
        "provider": "Aanbieder",
        "providerInfo": "Meer informatie",
        "result": "Resultaat",
        "size": "Grootte"
      },
      "messages": {
        "allMovedToTrash": "Alle afbeeldingen zijn naar de prullenbak verplaatst",
        "deleted": "Afbeelding verwijderd"
      },
      "prompts": {
        "prompt1": "Foto van een lieveheersbeestje vanuit vogelperspectief, zittend op een sappige groene grasspriet in een zonnige weide. Het lieveheersbeestje heeft felrode vleugels met zwarte stippen. Op de achtergrond zijn wazige bloemen en een helderblauwe lucht te zien. De scène is in een lichte, levendige stijl, met focus op het lieveheersbeestje.",
        "prompt2": "Een fotorealistisch portret van een jonge ingenieursstudente met kort zwart haar, die dromerig uit een groot raam in een modern universiteitsgebouw kijkt. De opname is in zacht, warm daglicht en de camera is op ooghoogte gepositioneerd. Op de achtergrond zijn wazige boekenplanken en technische tekeningen te zien, wat de scène een academische en inspirerende sfeer geeft.",
        "prompt3": "Een impressionistisch schilderij van een man van middelbare leeftijd die met een zwarte paraplu in de storm langs de oever van een woeste rivier loopt. De scène is weergegeven met zachte, vloeiende penseelstreken die de beweging van de wind en regen vastleggen. De lucht is in dramatische grijstinten, terwijl de rivier glinstert in diepe blauw- en groentinten. De man draagt een lange, donkere jas die in de wind wappert, en de kleuren van zijn jas en paraplu zijn licht vervaagd om de intensiteit van de storm te benadrukken."
      },
      "tooltips": {
        "generatePrompt": "Prompt optimaliseren",
        "generatePromptDisabled": "Voer eerst een prompt in om deze te optimaliseren"
      },
      "views": {
        "new": {
          "labels": {
            "imageStyle": "Kies een stijl"
          }
        }
      }
    }
  }
}
